<template>
  <div>
    <PageAllow controller="StockIns" action="getWaitShelveOnList" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="stock_order_code"
              v-model="options.stock_order_code"
              @text="stockInsKeyword = $event"
              :label="$t('Putaway.stockInsKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherStock v-model="stocksSelected" unclearable />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="stockInTypeSelected"
                  clearable
                  :items="$consts.stock_in_order.types"
                  :label="$t('Putaway.Fields.stock_in_type')"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="ext_code"
                  v-model="options.ext_code"
                  @text="extCodeKeyword = $event"
                  :label="$t('Putaway.Fields.ext_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="material_keyword"
                  v-model="options.key_word"
                  @text="materialKeyword = $event"
                  :label="$t('Putaway.keyword')"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stockOnLists"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.stock_order.type="{ item }">
            <v-chip
              small
              label
              :color="item.stock_order.type | stockOrderINTypesColor"
              :text-color="item.stock_order.type | stockOrderINTypesTextColor"
            >
              {{ item.stock_order.type | stockOrderINTypesText }}
            </v-chip>
          </template>
          <template v-slot:item.shelve_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.shelve_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.shelve_stock_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.wait_shelve_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.wait_shelve_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.wait_shelve_stock_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('StockIns', 'getShelveOnDetail')
              "
            >
              <template v-slot:activator="{}">
                <v-btn
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  :href="'/#/putaway/' + item.id"
                >
                  <v-icon x-small class="pe-1">fa-hands</v-icon>
                  {{ $t("Putaway.actions.putaway") }}
                </v-btn>
              </template>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStock from "@/components/plugins/SearcherStock";
import Putaway from "@/api/putaway";
const defaultOptions = {
  stock_order_code: "",
  ext_code: "",
  key_word: "",
  stock_ids: null,
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherStock,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.putaway"),
        disabled: true,
        href: "/putaway",
      },
    ],

    headers() {
      return [
        {
          text:
            i18n.t("Putaway.Fields.stock_in_code") +
            " / " +
            i18n.t("Putaway.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("Putaway.Fields.stock_in_type"),
          align: "start",
          sortable: false,
          value: "stock_order.type",
        },
        {
          text: i18n.t("Putaway.Fields.material_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("Putaway.Fields.stock_in_num"),
          align: "start",
          sortable: false,
          value: "shelve_num",
        },
        {
          text: i18n.t("Putaway.Fields.wait_putaway_num"),
          align: "start",
          sortable: false,
          value: "wait_shelve_num",
        },
        {
          text: i18n.t("Putaway.Fields.memo"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "memo",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },
  data: () => ({
    stockOnLists: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("putaway-options")
        ? sessionStorage.getItem("putaway-options")
        : JSON.stringify(defaultOptions)
    ),
    stockInsKeyword: "",
    extCodeKeyword: "",
    materialKeyword: "",
    stocksSelected: null,
    stockInTypeSelected: null,
    currentItemMode: null,
    currentItem: null,
  }),

  mounted() {
    if (
      this.$route.query.stock_order_code &&
      this.$route.query.stock_id &&
      this.$route.query.stock_in_type
    ) {
      this.stockInsKeyword = this.$route.query.stock_order_code;
      this.stocksSelected = { id: this.$route.query.stock_id };
      this.stockInTypeSelected = Number(this.$route.query.stock_in_type);
      this.onSearch();
    } else {
      this.$commonUtils
        .loadOptions("putaway", ["stocksSelected", "stockInTypeSelected"])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
            } else this.resetSearch();

            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "stocksSelected":
                  this.stocksSelected = selected.value;
                  break;
                case "stockInTypeSelected":
                  this.stockInTypeSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
    }
  },

  methods: {
    resetSearch() {
      this.stockInTypeSelected = null;
      this.stocksSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [
        this.$refs.stock_order_code,
        this.$refs.ext_code,
        this.$refs.material_keyword,
      ].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockInsKeyword,
        ext_code: this.extCodeKeyword,
        key_word: this.materialKeyword,
      });
    },
    getStockOnListsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Putaway.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockOnLists = response.data.stock_on_details;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem)
          this.$router.replace("/putaway?id=" + this.currentItem.id);
        else this.$router.replace("/putaway");
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStockOnListsFromAPI();
        sessionStorage.setItem("putaway-options", JSON.stringify(this.options));
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.id
          : "";
        sessionStorage.setItem(
          "putaway-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    stockInTypeSelected: {
      handler() {
        this.options.type = this.stockInTypeSelected
          ? this.stockInTypeSelected
          : "";
        sessionStorage.setItem(
          "putaway-stockInTypeSelected",
          JSON.stringify(this.stockInTypeSelected)
        );
      },
    },
  },
};
</script>